import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import TrackingCell from "../Reusable/DataTable/TrackingCell";
import Modal from "../Reusable/Modal";
import Spinner from "../Reusable/Spinner";
import TextField from "../Reusable/TextInput";
import ChangeStatus from "./ChangeStatus";
import DriverForm from "./DriverForm";
import VehicleForm from "./VehicleForm";
import useGetHook from "../../customHooks/useGetHook";

const EditReturnOrder = (props: any) => {
  const [statuslist, setStatusList] = useState<any>([]);
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);
  const {
    handleEdit,
    isLoading,
    data,
    handleAttachConsignment,
    handlePrint,
    handleToggleMarkAsDone,
    defaultValue,
    isPrintLoading,
    gridData,
    handleStatusChange,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    handleCreate,
    isPostLoading,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    // resolver: yupResolver(createPickupRequestValidationForm),
    defaultValues: async () => {
      return {
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        merchant: {
          name: data?.merchant?.user?.full_name,
          id: data?.merchant?.id,
        },
        note: data?.note,
      };
    },
  });

  const { data: returnOrderItems } = useGetHook({
    queryKey: ["Return-order-items"],
    url: APIS.RTV_ORDER_ITEMS,
    params: { rtv_order: data?.id, limit: 1, offset: 0 },
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      if (!data?.is_active) {
        handlecheckConsignments(event.target.value, setError);
      } else if (statuslist?.length > 1 && defaultValue?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          defaultValue[0]?.id,
          setError
        );
      } else if (statuslist?.length === 1) {
        handleAttachConsignment(
          event.target.value,
          statuslist[0]?.id,
          setError
        );
      } else {
        toast.error("Please select one status first");
      }
      event.target.value = "";
    }
  };

  const defaultColumns: any = [
    {
      header: "WayBill",
      accessorKey: "order.tracking_number",
      cell: TrackingCell,
    },
    {
      header: "Vendor",
      accessorKey: "order.vendor.user.full_name",
      cell: NACell,
    },
    {
      header: "Origin",
      accessorKey: "order.pickup_branch.name",
      cell: NACell,
    },
    {
      header: "Destination",
      accessorKey: "order.destination.name",
      cell: NACell,
    },
    {
      header: "Weight",
      accessorKey: "order.weight",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {row?.original?.order?.package_type?.unit === "Gm"
                ? Number(getValue() * 1000) || 0
                : getValue() || 0}
              <span className="text-gray-500 text-xs">
                {row?.original?.order?.package_type?.unit}
              </span>
            </p>
          </>
        );
      },
    },
  ];
  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  useEffect(() => {
    {
      gridData?.map((x: any) => {
        if (x?.name === "Intermediate") {
          setStatusList(x?.status_id);
        }
      });
    }
  }, [gridData]);
  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={!data?.is_active || returnOrderItems?.count > 0}
          >
            <div className={tw`mx-4`}>
              <div className={tw`grid grid-cols-3 gap-x-4 `}>
                <div className={tw`w-full flex  `}>
                  <div className={tw`w-full`}>
                    <ComboboxInput
                      url={APIS.DRIVER}
                      queryKey={"driver"}
                      register={register("driver")}
                      errors={errors?.driver}
                      name={"driver"}
                      label={"Driver"}
                      setValue={setValue}
                      placeholder={"Search driver"}
                      getValues={getValues}
                      clearErrors={clearErrors}
                    />
                  </div>
                  <button
                    className={tw`border px-4  py-2 h-10 relative top-10`}
                    type="button"
                    onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
                  >
                    +
                  </button>
                </div>
                <ComboboxInput
                  url={APIS.MERCHANT}
                  queryKey={"merchant"}
                  register={register("merchant")}
                  errors={errors?.merchant}
                  name={"merchant"}
                  label={"Vendor"}
                  setValue={setValue}
                  placeholder={"Select Vendor"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
                <div>
                  <TextField
                    label={"Note"}
                    register={register(`note`)}
                    errors={errors?.note}
                  />
                </div>
              </div>
            </div>
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_rtv_return"]}
        renderNoAccess={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleEdit}
            setError={setError}
            buttonLabel={"Update"}
            isLoading={isLoading}
            disabled={true}
          >
            <div className={tw`mx-4`}>
              <div className={tw`grid grid-cols-3 gap-x-4 `}>
                <div className={tw`w-full flex  `}>
                  <div className={tw`w-full`}>
                    <ComboboxInput
                      url={APIS.DRIVER}
                      queryKey={"driver"}
                      disabled={true}
                      register={register("driver")}
                      errors={errors?.driver}
                      name={"driver"}
                      label={"Driver"}
                      setValue={setValue}
                      placeholder={"Search driver"}
                      getValues={getValues}
                      clearErrors={clearErrors}
                    />
                  </div>
                  <button
                    className={tw`border px-4  py-2 h-10 relative top-11`}
                    type="button"
                    disabled={true}
                    onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
                  >
                    +
                  </button>
                </div>
                <ComboboxInput
                  url={APIS.MERCHANT}
                  queryKey={"merchant"}
                  register={register("merchant")}
                  errors={errors?.merchant}
                  name={"merchant"}
                  disabled={true}
                  label={"Vendor"}
                  setValue={setValue}
                  placeholder={"Select Vendor"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
                <div>
                  <TextField
                    label={"Note"}
                    register={register(`note`)}
                    disabled={true}
                    errors={errors?.note}
                  />
                </div>
              </div>
            </div>
          </FormLayout>
        }
      />
      <Card title="Barcode Scanner">
        <>
          <div className={tw`flex flex-col relative -top-6 items-end w-full`}>
            <ChangeStatus
              handleAttachConsignment={handleAttachConsignment}
              gridData={statuslist}
              handleStatusChange={handleStatusChange}
            />

            <div className={tw`grid grid-cols-1 w-full`}>
              <div>
                <input
                  type="text"
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                  onPaste={preventCopyPaste}
                  onKeyDown={handleKeyDown}
                />
                {errors?.tracking_number && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.tracking_number?.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      </Card>

      <DataTable
        url={APIS.RTV_ORDER_ITEMS}
        queryKey={"Return-order-items"}
        columns={defaultColumns}
        params={{ rtv_order: data?.id }}
        tableName={"return-order-items"}
        actionMenu={
          <div className={tw`w-full text-right`}>
            {data?.is_active ? (
              <button
                className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 `}
                onClick={handleToggleMarkAsDone}
              >
                Mark As Done
              </button>
            ) : (
              ""
            )}
            <button
              className={tw`p-1 px-5 rounded-sm border border-primary mr-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1 `}
              disabled={isPrintLoading}
              onClick={() => handlePrint()}
            >
              {isPrintLoading ? <Spinner /> : "Print"}
            </button>
          </div>
        }
      />
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setOpenAddVehiclePopup={setOpenAddVehiclePopup}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />

      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              setOpenAddDriverPopup={setOpenAddDriverPopup}
              isDriverLoading={isDriverLoading}
              handleCreate={handleCreate}
              isPostLoading={isPostLoading}
            />
          </>
        }
      />
    </>
  );
};

export default EditReturnOrder;
